import * as React from "react";
import {PrimaryLayout} from "../widgets/PrimaryLayout";
import {SecondaryBar} from "../widgets/SecondaryBar";
import {PageEnums} from "../nav/PageEnums";
import {UIState} from "data/UIState";
import {computed} from "mobx";
import {generateBadgeGroups} from "components/badges/BadgeGroup";
import DashboardData from "data/DashboardData";
import {BadgeCard} from "components/badges/BadgeCard";

import './BadgeHistory.pcss';

export const BadgeHistory = () => {

  const groupedBadges = generateBadgeGroups(DashboardData.badgedDashboardSolutions);

  let points = 0;
  let badges = DashboardData.badgedDashboardSolutions.length;
  for(let i = 0; i < badges; i++) {
    points += DashboardData.badgedDashboardSolutions[i].points;
  }

  return (
    <PrimaryLayout className={"badge-history"}>
      <SecondaryBar
        title={"Badge Gallery"}
        subTitle={`${badges} badge${badges!==1?'s':''} • ${points} point${points!==1?'s':''}`}
        buttonAction={()=>{ UIState.currentPage = PageEnums.dashboard }}
        buttonLabel={"Back to Dashboard"}

      >
      </SecondaryBar>

      <div style={{height:'30px'}}></div>

      <div className={"badge-history-inner"}>
        {groupedBadges.map(badgeGroup => {
          if(0===badgeGroup.badgedDashboardSolutions.length) {
            return null;
          }
          return (
            <div className={"badge-group"}>
              <h2 className={'level2'}>{badgeGroup.name} &bull; <span className={"not-bold"}>{`${badgeGroup.badges} badge${badgeGroup.badges!==1?'s':''} • ${badgeGroup.points} point${badgeGroup.points!==1?'s':''}`}</span></h2>
              {badgeGroup.badgedDashboardSolutions.map(sol => <BadgeCard key={sol._id} solution={sol} /> )}
            </div>
          );
        })}
      </div>

    </PrimaryLayout>
  )

}